import {Outlet} from "react-router-dom";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {GLOBAL_CONFIG} from "../../../config/config";
import {AppFooter} from "./Footer";
import {AppHeader} from "./Header";
import {AppSidebar} from "./Sidebar";
import styles from "./Layout.module.scss";

const mainColor = GLOBAL_CONFIG.mainSettings.mainColor;
// const secondColor = GLOBAL_CONFIG.mainSettings.secondColor;

const bg = `url(${mainColor})`;

export const AppLayout = () => {
  return (
    <AppFlex direction="column" unit="0" style={{background: bg}}>
      <AppHeader/>
      <AppFlex unit="0" direction="row" className={styles.container}>
        <AppSidebar/>
        <Outlet/>
      </AppFlex>
      <AppFooter/>
    </AppFlex>
  );
};
